import { type ReactElement } from 'react'
import { Group, Stack, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'
import { VISIBILITY_STATES, type VisibilityState } from './node/VisibilityCornerFold'
import classes from './hierarchyViewport.module.css'

export const VisibilityLegend = (): ReactElement => {
  return (
    <Stack gap='xs' className={classes.visibilityLegend}>
      {Object.entries(VISIBILITY_STATES).map(([variant, state]) => (
        <LegendRow key={variant} {...state} />
      ))}
    </Stack>
  )
}

const LegendRow = ({ color, icon, label }: VisibilityState): ReactElement => {
  const { t } = useTranslation()

  return (
    <Group gap='xs' wrap='nowrap'>
      <div className='flex h-4 w-4 shrink-0 items-center justify-center rounded-sm' style={{ backgroundColor: color }}>
        <MaterialSymbolIcon filled color='#ffffff' icon={icon} size={11} />
      </div>
      <Text size='xs'>{t(label)}</Text>
    </Group>
  )
}
